<template>
    <div class="camere-selector">
        <input :placeholder="placeholder" :value="summaryText" @click="onShowClose" readonly/>
        <div v-show="show" class="popup">
            <div class="items">
                <CamereSelectorItem :title="'Camera ' + (index+1)" v-for="(item, index) in camere" :key="index" :index="index" :value="item" @change="onChangeCamera" />
                <div class="text-center mt-2 py-2">
                    <a v-if="camere.length < 4" href="javascript:void(0)" class="btn btn-success py-1 btn-sm mb-2 text-uppercase" @click="onAddCamera">Aggiungi</a>
                    <a v-if="camere.length > 1" href="javascript:void(0)" class="btn btn-sm py-1 btn-danger mb-2 text-uppercase" @click="onRemoveCamera">
                        Rimuovi
                    </a>
                </div>
            </div>
            <div class="text-center">
                <button class="btn btn-primary btn-sm py-1 px-5" type="button" @click="onConfirm">Conferma</button>
            </div>
        </div>
    </div>
</template>

<script>
import InputIncrement from './InputIncrement'
import CustomSimpleSelect from './CustomSimpleSelect'
import CamereSelectorItem from './camere-selector/CamereSelectorItem'
import {countAdults, countChilds, clone} from '../../../utils/helper'
export default {
  name: 'CamereSelector',
  components: {CamereSelectorItem, CustomSimpleSelect, InputIncrement},
  props: {
    placeholder: {
      type: String,
      default: 'Configura camere...'
    },
    value: {
      type: Array,
      default () {
        return [{id: 1, adults: 2, childs: []}]
      }
    }
  },
  watch: {
    value () {
      this.camere = clone(this.value)
    }
  },
  data () {
    return {
      camere: clone(this.value),
      show: false
    }
  },
  computed: {
    summaryText () {
      return this.generateText()
    }
  },
  methods: {
    onAddCamera () {
      this.camere.push({index: this.camere.length, adults: 1, childs: []})
    },
    onRemoveCamera () {
      this.camere.pop()
    },
    onChangeCamera: function (data) {
      this.camere[data.index] = data
    },
    onShowClose () {
      this.show = !this.show
      if (!this.show) {
        this.onConfirm()
      }
    },
    onConfirm () {
      this.camereText = this.generateText()
      this.show = false
      this.$emit('input', this.payload())
    },
    generateText () {
      let text = ''
      if (this.value && this.value.length > 0) {
        text += this.value.length + (this.value.length === 1 ? ' camera: ' : ' camere: ')
        const adults = this.countAdults()
        text += adults + (adults === 1 ? ' adulto' : ' adulti')
        const childs = this.countChilds()
        if (childs > 0) {
          text += ', ' + childs + (childs === 1 ? ' bambino' : ' bambini')
        }
      }
      return text
    },
    countChilds () {
      return countChilds(this.value)
    },
    countAdults () {
      return countAdults(this.value)
    },
    payload () {
      return this.camere.map(item => {
        return {adults: item.adults, childs: item.childs}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/CamereSelector.vue